import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-free-trial-feature-dialog',
    templateUrl: './free-trial-feature-dialog.component.html',
    styleUrls: ['./free-trial-feature-dialog.component.css'],
    standalone: false
})
export class FreeTrialFeatureDialogComponent {
  @Input() FreeTrialFeatureDialogVisible: boolean = false;
  @Output() onclose = new EventEmitter<boolean>();

  closeDialog() {
    this.FreeTrialFeatureDialogVisible = false;
    localStorage.setItem('FreeTrialFeatureDialogVisible', 'false');
    this.onclose.emit(this.FreeTrialFeatureDialogVisible);
  }
}
